/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSendForward: {
  name: 'send-forward';
  data: string;
} = {
  name: 'send-forward',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h12v12H4V4Zm18 3a1 1 0 1 0-2 0v13H7a1 1 0 1 0 0 2h13a2 2 0 0 0 2-2V7Z" fill="currentColor"/></svg>`,
};
